import { render, staticRenderFns } from "./AddEditGeograficPopup.vue?vue&type=template&id=3edb1f18"
import script from "./AddEditGeograficPopup.vue?vue&type=script&lang=ts"
export * from "./AddEditGeograficPopup.vue?vue&type=script&lang=ts"
import style0 from "./AddEditGeograficPopup.vue?vue&type=style&index=0&id=3edb1f18&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports